import React, { Component } from 'react';
import _ from 'lodash';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import SelectUI from '../../../components/SelectUI';
import InputUI from '../../../components/InputUI';
import { FormControl } from 'material-ui/Form';
import { InputLabel } from 'material-ui/Input';
import validation from '../../../constants/validation';
import { storeCarMakeIntoQueryParams } from './actions';
import fuelMapping from '../../../constants/fuelMapping';

const {
  REQUIRED_FIELD
} = validation;

const MINIMUN_YEAR = 1900


const onSubmit = (values, dispatch, props) => {
  const queryParams = props.queryParams || {}

  dispatch(storeCarMakeIntoQueryParams({
    ...queryParams,
    ...values,
  }, props.makes))
}

const validate = (values) => {
  const errors = {}

  if (!values) {
    errors.year = REQUIRED_FIELD
    errors.make = REQUIRED_FIELD
    errors.model = REQUIRED_FIELD
    errors.engine = REQUIRED_FIELD
  } else {
    if (!values.make || values.make === "") {
      errors.make = REQUIRED_FIELD
    }
    if (!values.model || values.model === "") {
      errors.model = REQUIRED_FIELD
    }
    if (!values.engine || values.engine === "") {
      errors.engine = REQUIRED_FIELD
    }
    if (!values.year || values.year === '') {
      errors.year = REQUIRED_FIELD
    } else if (Number.isNaN(Number(values.year)) || Number(values.year) < MINIMUN_YEAR || Number(values.year) > (new Date()).getFullYear()) {
      errors.year = `Debe ser un número entre ${MINIMUN_YEAR} y ${(new Date()).getFullYear()}`
    }
  }

  return errors;
}

const form = reduxForm({
  form: 'makesModelSelectsForms',
  onSubmit,
  validate,
})

class MakesModelSelectsForms extends Component {

  state = {
    selectedMake: null,
    selectedModel: null,
    selectedEngine: null,
  }

  componentDidMount() {
    document.getElementById("registrationYear").min = MINIMUN_YEAR
    document.getElementById("registrationYear").max = (new Date()).getFullYear(); // EZ Clap
  }

  getMakesOptions = () => this.props.makes.map(e => ({ label: e.make, value: e.make }))

  getModelsOptions = () => {
    let result = []

    if (this.state.selectedMake) {
      const make = _.find(this.props.makes, { make: this.state.selectedMake });
      if (make) {
        result = make.models.map(e => ({ label: e.model, value: e.model }));
      }
    }

    return result;
  }

  getEnginesOptions = () => {
    let result = [];

    if (this.state.selectedMake && this.state.selectedModel) {
      const make = _.find(this.props.makes, { make: this.state.selectedMake });
      if (make) {
        const model = _.find(make.models, { model: this.state.selectedModel });
        if (model) {
          result = model.engines.map(e => ({ label: `${e.engine} ${fuelMapping[e.fuel] || ''}`, value: e.engineId }))
        }
      }
    }

    return result;
  }

  handleMakeChange = ({ target: { value } }) => {
    this.setState({
      selectedMake: value,
      selectedModel: null, // Resets the value if any
      selectedEngine: null, // Resets the value if any
    })
  }

  handleModelChange = ({ target: { value } }) => {
    this.setState({
      selectedModel: value,
      selectedEngine: null, // Resets the value if any
    })
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={6} xs={12}>
            <FormControl className="w-100 mb-2">
              <InputLabel htmlFor="advisor">Marca</InputLabel>
              <Field
                component={SelectUI}
                name="make"
                options={this.getMakesOptions()}
                onChange={this.handleMakeChange}
              // disabled={readOnly || advisors === false}
              />
            </FormControl>
          </Col>
          <Col md={6} xs={12}>
            <FormControl className="w-100 mb-2">
              <InputLabel htmlFor="advisor">Modelo</InputLabel>
              <Field
                component={SelectUI}
                name="model"
                options={this.getModelsOptions()}
                disabled={!this.state.selectedMake}
                onChange={this.handleModelChange}
              />
            </FormControl>
          </Col>
          <Col md={6} xs={12}>
            <FormControl className="w-100 mb-2">
              <InputLabel htmlFor="advisor">Motor</InputLabel>
              <Field
                component={SelectUI}
                name="engine"
                options={this.getEnginesOptions()}
                disabled={!this.state.selectedMake || !this.state.selectedModel}
              />
            </FormControl>
          </Col>
          <Col md={6} xs={12}>
            <Field
              name="year"
              id="registrationYear"
              label="Año de matriculación"
              component={InputUI}
              style={{ marginTop: 0 }}
              type="number"
            // style={{ resize: 'none', width: 500 }}
            />
          </Col>
        </Row>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  makes: state.make.makes,
  queryParams: state.checkout.checkoutRoot.queryParams,
});

export default connect(mapStateToProps)(form(MakesModelSelectsForms));



// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/makesModelSelectsForms.js